import { AxiosError } from 'axios';
import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as storageActions from 'store/amwell/storage/actions';
import { Consumer } from './types';
import * as actions from './actions';

export type InformationState = Readonly<{
  token: Nullable<string>;
  data: Nullable<Consumer>;
  loading: {
    token: boolean;
    data: boolean;
    action: boolean;
  };
  errors: {
    token: Nullable<AxiosError | Error>;
    data: Nullable<Error>;
    action: Nullable<Error>;
  };
}>;

export const informationInitialState: InformationState = {
  token: null,
  data: null,
  loading: { token: false, data: false, action: false },
  errors: { token: null, data: null, action: null }
};

/**
 * Primary Consumer Reducer
 * @desc Main logged in consumer
 */

export const informationReducer = createReducer(informationInitialState, {
  [actions.GET_VISIT_TOKEN]: state => {
    state.loading.token = true;
    state.errors.token = null;
  },
  [actions.GET_VISIT_TOKEN_FAIL]: (state, action) => {
    state.loading.token = false;
    state.errors.token = action.payload;
  },
  [actions.GET_VISIT_TOKEN_SUCCESS]: (state, action) => {
    state.loading.token = false;
    state.token = action.payload;
  },
  [actions.LOGIN]: state => {
    state.loading.data = true;
    state.errors.data = null;
  },
  [actions.LOGIN_FAIL]: (state, action) => {
    state.errors.data = action.error;
    state.loading.data = false;
  },
  [actions.LOGIN_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.data = false;
  },
  [actions.LOGIN_WITH_TOKEN]: state => {
    state.loading.token = true;
    state.errors.token = null;
  },
  [actions.LOGIN_WITH_TOKEN_FAIL]: (state, action) => {
    state.errors.token = action.error;
    state.loading.token = false;
  },
  [actions.LOGIN_WITH_TOKEN_SUCCESS]: (state, action) => {
    state.data = action.payload;
    state.loading.token = false;
  },
  [actions.LOGOUT]: state => {
    state.loading.data = true;
    state.errors.data = null;
  },
  [actions.LOGOUT_FAIL]: (state, action) => {
    state.errors.data = action.error;
    state.loading.data = false;
  },
  [actions.LOGOUT_SUCCESS]: state => {
    state.data = null;
    state.loading.data = false;
  },
  [actions.UPDATE_CONSUMER_LEGAL_RESIDENCE_SUCCESS]: (state, action) => {
    state.data = action.payload;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.data = action.payload.consumer;
  }
});
